// AWS Amplify Configuration
import { isProduction } from './utils/envUtils';

const productionHostname = window.location.hostname;

const productionConfig = {
    Auth: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_JtFAfIy1V',
        userPoolWebClientId: '3bffkf5q4eb1sdvm3rg3l0rhk6',
        oauth: {
            domain: 'prod-us-east-1.auth.misfitsmarket.com',
            scope: ['profile', 'email', 'openid'],
            redirectSignIn: `https://${productionHostname}/lettuce/`,
            redirectSignOut: `https://${productionHostname}/lettuce/login`,
            responseType: 'code',
        },
    },
};

const developmentConfig = {
    Auth: {
        region: 'us-east-1',
        userPoolId: 'us-east-1_47dJcNNxR',
        userPoolWebClientId: '1j14hcf3ek5dmvfjemd3p8dkb2',
        oauth: {
            domain: 'dev-us-east-1.auth.misfitsmarket.com',
            scope: ['profile', 'email', 'openid'],
            redirectSignIn: 'https://training.misfitsmarket.com/lettuce/',
            redirectSignOut: 'https://training.misfitsmarket.com/lettuce/login',
            responseType: 'code',
        },
    },
};

const awsConfig = isProduction() ? productionConfig : developmentConfig;

export default awsConfig;
